/**
 * Parse request body JSON from Gate-0 form fields.
 * @param {string} raw
 * @returns {{ ok: true, value: unknown } | { ok: false, error: string }}
 */
export function parseRequestBodyField(raw) {
  const trimmed = String(raw || "").trim();
  if (!trimmed) return { ok: true, value: {} };
  try {
    return { ok: true, value: JSON.parse(trimmed) };
  } catch {
    return { ok: false, error: "Request body must be valid JSON." };
  }
}

/**
 * Build payloads[] for app_config from form endpoint row.
 * @param {{ requestBody?: string, payloads?: Array<{ name?: string, body?: string, expectStatus?: string }> }} ep
 */
export function buildEndpointProbePayloads(ep) {
  const method = String(ep.method || "GET").toUpperCase();
  if (!["POST", "PUT", "PATCH"].includes(method)) return { payloads: undefined, request_body: undefined };

  const variants = Array.isArray(ep.payloads) ? ep.payloads.filter((p) => p && String(p.name || p.body || "").trim()) : [];
  if (variants.length > 0) {
    const payloads = [];
    for (const v of variants) {
      const parsed =
        typeof v.body === "string"
          ? parseRequestBodyField(v.body || "{}")
          : { ok: true, value: v.body ?? {} };
      if (!parsed.ok) return { error: parsed.error };
      const expectRaw = String(v.expectStatus ?? v.expect_status ?? "").trim();
      payloads.push({
        name: String(v.name || "variant").trim() || "variant",
        body: parsed.value,
        expect_status: expectRaw ? parseInt(expectRaw, 10) : null,
      });
    }
    return { payloads };
  }

  const bodyRaw = String(ep.requestBody ?? ep.request_body ?? "").trim();
  if (!bodyRaw) return { request_body: {} };
  const parsed = parseRequestBodyField(bodyRaw);
  if (!parsed.ok) return { error: parsed.error };
  return { request_body: parsed.value };
}
